import { ChevronLeft , MessageCircleMore} from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar'
import { useNavigate, useParams } from 'react-router-dom'
import { useUserContext } from '../contexts/user'
import { useLoaderContext } from '../contexts/loader'
import { usePopUpContext } from '../contexts/Popup'
import { useCheckForNewToken } from '../checkForNewToken';

const ResultPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { user, userJWT, setUserJWT, setUserInfo, setUserIndex, setUser, appLanguage } = useUserContext();
    const { setIsLoading } = useLoaderContext();
    const { setMessageContent } = usePopUpContext();
    const { checkForNewToken } = useCheckForNewToken();

    const [userResult, setUserResult] = useState({});
    const [quizAnswersDetails, setQuizAnswersDetails] = useState({ correctAnswers: 0, wrongAnswers: 0, });
    const [userPercentage, setUserPercentage] = useState(0);

    useEffect(() => {
        setIsLoading(prev => prev + 1);
        fetch("https://quiz-battle-api.vercel.app/api/result", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${userJWT}`,
            },
            body: JSON.stringify({
                userID: user,
                quizID: id,
            }),
        })
            .then(res => res.json())
            .then(data => {
                checkForNewToken(data, setUserJWT , setUserInfo , setUser , setUserIndex , navigate , setMessageContent);
                if (data.failed || data.ok === 0) {
                    setIsLoading(prev => prev !== 0 ? prev - 1 : prev);
                    setMessageContent({
                        title: appLanguage === "ar" ? "خطأ في جلب النتيجة" : "Result Fetching Error",
                        message: appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء جلب نتيجتك." : "Oops! something went wrong while fetching you result.",
                    })
                    navigate("/home");
                } else {
                    if (!data.quizQuestions || !data.result) {
                        setIsLoading(prev => prev !== 0 ? prev - 1 : prev);

                        setMessageContent({
                            title: appLanguage === "ar" ? "خطأ في جلب النتيجة" : "Result Fetching Error",
                            message: appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء جلب نتيجتك." : "Oops! something went wrong while fetching your result.",
                        })
                        navigate("/home");
                    } else {
                        setIsLoading(prev => prev !== 0 ? prev - 1 : prev);

                        setUserResult(data);
                        let correctAnswers = 0;
                        let wrongAnswers = 0;
                        for (let i = 0; i < data.quizQuestions.questions.length; i++) {
                            if (data.quizQuestions.questions[i].correctAnswer === data.result.answers[i]) {
                                correctAnswers += 1;
                            } else {
                                wrongAnswers += 1;
                            }
                        }
                        setUserPercentage(Math.floor(correctAnswers / data.quizQuestions.questions.length * 100));
                        setQuizAnswersDetails({
                            correctAnswers: correctAnswers,
                            wrongAnswers: wrongAnswers,
                        })
                    }
                }
            }).catch(err => {
                console.log(err);
                navigate("/home");
                setIsLoading(prev => prev !== 0 ? prev - 1 : prev);

                setMessageContent({
                    title: appLanguage === "ar" ? "خطأ في جلب النتيجة" : "Result Fetching Error",
                    message: appLanguage === "ar" ? "عذراً! حدث خطأ ما أثناء جلب نتيجتك." : "Oops! something went wrong while fetching your result.",
                })
            })
    }, [])

    return (
        <div className="result_page_container">
            <header>
                <ChevronLeft onClick={() => navigate("/home")} />
                <p>{appLanguage === "ar" ? "نتيجة الاختبار" : "Quiz Result"}</p>
            </header>
            <div className="user_result_container">
                <div className="details">
                    <p className="title">{appLanguage === "ar" ? "التفاصيل" : "Details"}</p>
                    <div className="content">
                        <div className="points">
                            <p className="key">{appLanguage === "ar" ? "النقاط :" : "Points :"}</p>
                            <p className="value">{userResult.result ? userResult.result.points : 0}</p>
                        </div>
                        <div className="correct_answers">
                            <p className="key">{appLanguage === "ar" ? "إجابات صحيحة :" : "Correct Answers : "}</p>
                            <p className="value">{quizAnswersDetails.correctAnswers}</p>
                        </div>
                        <div className="wrong_answers">
                            <p className="key">{appLanguage === "ar" ? "إجابات خاطئة :" : "Wrong Answers : "}</p>
                            <p className="value">{quizAnswersDetails.wrongAnswers}</p>
                        </div>
                    </div>
                </div>
                <div className="percentage">
                    <p className="title">{appLanguage === "ar" ? "النسبة المئوية" : "Percentage"}</p>
                    <CircularProgressbar styles={buildStyles({
                        pathColor: "#00f1a1",
                        textColor: "#FFF",
                        trailColor: "#FFFFFF33",
                        pathTransitionDuration: 3,
                    })} value={userPercentage} text={`${userPercentage}%`} />
                </div>
            </div>
            <button className="chat" onClick={() => navigate("/chat/" + id)}>{appLanguage === "ar" ? "محادثة" : "Chat"} <MessageCircleMore /></button>
            <div className="questions">
                <p className="title">{appLanguage === "ar" ? "الأسئلة" : "Questions"}</p>
                <div className="content">
                    {
                        userResult.quizQuestions ?
                            userResult.quizQuestions.questions.map((question, i) => {
                                return (
                                    <div className="question" key={"question_" + i}>
                                        {userResult.result.answers[i] === ' ' || userResult.result.answers[i].empty ? <span>{appLanguage === "ar" ? "لا توجد إجابة" : "No Answer"}</span> : undefined}
                                        <p className="question_text">{question.question}</p>
                                        <div className="answers">
                                            <button className={"answer " + (question.answers[0] === userResult.result.answers[i] ? "choosed_answer" : "") + " " + (question.answers[0] === question.correctAnswer ? "correct_answer" : "")}>{question.answers[0]}</button>
                                            <button className={"answer " + (question.answers[1] === userResult.result.answers[i] ? "choosed_answer" : "") + " " + (question.answers[1] === question.correctAnswer ? "correct_answer" : "")}>{question.answers[1]}</button>
                                            <button className={"answer " + (question.answers[2] === userResult.result.answers[i] ? "choosed_answer" : "") + " " + (question.answers[2] === question.correctAnswer ? "correct_answer" : "")}>{question.answers[2]}</button>
                                            <button className={"answer " + (question.answers[3] === userResult.result.answers[i] ? "choosed_answer" : "") + " " + (question.answers[3] === question.correctAnswer ? "correct_answer" : "")}>{question.answers[3]}</button>
                                        </div>
                                    </div>
                                )
                            })
                            : <p>{appLanguage === "ar" ? "جاري جلب الأسئلة" : "Fetching Questions"}</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default ResultPage;